import { getBackendRoute } from 'ComponentLibrary/src/common/environment'
import { ValuationApiClient, type ValuationApiConfig } from '@einwert/valuation-api-client'
import { getAccessToken } from 'ClientPortal/src/services/Auth'
import { v4 as uuidv4 } from 'uuid'
import { getCurrentScope } from '@sentry/react'

export function getValuationApiClient() {
    const config: ValuationApiConfig = {
        baseUrl: getBackendRoute(),
        getToken: getAccessToken,
        getHeaders: () => {
            const correlationId = uuidv4()
            getCurrentScope().setTag('correlation_id', correlationId)
            return { 'x-correlation-id': correlationId }
        },
    }
    return new ValuationApiClient(config)
}
